<app-nav-menu></app-nav-menu>
<router-outlet></router-outlet>
<footer>
    <!-- <app-footer></app-footer> -->
</footer>